(function ($) {
    "use strict";
    var nll = null;
    var doc = document;
    var asc = "asc";
    var desc = "desc";

    // Vainilla JS function to merge the contents of two or more objects 
    // together into the first object as jQuery.extend()
    // Taken from: http://youmightnotneedjquery.com/
    function extendDefaults(out) {
        out = out || {};

        for (var i = 1,
				 argumentsLength = arguments.length; i < argumentsLength; i++) {
            var args = arguments[i];
            if (args) {
                for (var key in args) {
                    args.hasOwnProperty(key) && (out[key] = args[key]);
                }
            }
        }

        return out;
    };

    function getLen(s, l) {
        return undefined !== s && nll !== s ? s.length : l;
    };

    function isValidFunction(s) {
        return "function" === typeof (s) ? s : nll;
    };

    function defaultSort(a, b) {
        return a > b ? 1 : -1;
    }

    // Taken from http://www.davekoelle.com/files/alphanum.js
    function naturalSort(a, b) {
        var x = 0;

        function chunkify(t) {
            var tz = [];
            var y = -1;
            var n = 0;
            var i;
            var j;
            x = 0;

            while (i = (j = t.charAt(x++)).charCodeAt(0)) {
                var m = (i == 46 || (i >= 48 && i <= 57));

                if (m !== n) {
                    tz[++y] = "";
                    n = m;
                }

                tz[y] += j;
            }

            return tz;
        }

        var aa = chunkify(a);
        var bb = chunkify(b);

        for (x = 0; aa[x] && bb[x]; x++) {
            if (aa[x] !== bb[x]) {
                var c = Number(aa[x]), d = Number(bb[x]);

                if (c == aa[x] && d == bb[x]) {
                    return c - d;
                } else {
                    return (aa[x] > bb[x]) ? 1 : -1;
                }
            }
        }

        return aa.length - bb.length;
    }

    function validateOrderOption(order) {
        if ("string" !== typeof (order) || 0 >= order.length) {
            return asc;
        }

        order = order.toLowerCase();
        return order !== asc && order !== desc ? asc : order;
    };

    function attachBind(sort, trigger, event) {
        for (var i = 0, l = trigger.length; i < l; i++) {
            [].slice.call(doc.querySelectorAll(trigger[i]))
                .map(function (e) {
                    e.addEventListener(event[i], sort);
                });
        };
    };

    function bindCriterias(attrs, orders, functions) {
        var criterias = [];

        if ("undefined" !== typeof (attrs)) {
            for (var i = 0,
					 len = attrs.length,
					 ordLen = getLen(orders, -1),
					 funcLen = getLen(functions, -1) ; i < len; i++, ordLen--) {
                var ord = 0 <= ordLen ? validateOrderOption(orders[i]) : asc;
                var func = 0 <= funcLen ? isValidFunction(functions[i]) : nll;

                criterias.push([attrs[i], ord, func]);
            }
        }

        return criterias;
    };

    function getElementsToSort(selector, filters) {
        if ("string" === typeof (selector) && 0 < selector.length) {
            var f = filters ? filters.length : 0;

            return [].slice.call(doc.querySelectorAll(selector)).map(function (e) {
                e.style.display = "";
                e.hidden = false;

                for (var i = 0; i < f ; i++) {
                    if (!filters[i](e)) {
                        e.style.display = "none";
                        break;
                    }
                }

                return e;
            });
        }
    };

    function getAttributes(domElement, attr, caseSensitive) {
        var val;

        if ("value" === attr) {
            return (val = domElement.innerText || domElement.textContent) ? (caseSensitive ? val : val.toLowerCase()) : "";
        }

        val = domElement.getAttribute(attr);
        return attr ? (val ? (caseSensitive ? val : val.toLowerCase()) : "") : domElement;
    }

    function applyToDom(elementsSorted, isDesc) {
        elementsSorted.map(function (e) {
            if (e) {
                var parent = e.parentNode;
                parent.insertBefore(e, isDesc ? null : parent.firstChild);
            }
        });
    }

    function sortBy(a, b, criterias, caseSensitive, sortFunc) {
        for (var i = 0,
			    l = getLen(criterias, 0) ; i < l; i++) {
            var c = criterias[i];
            var attr = c[0];
            var ord = c[1];
            var func = isValidFunction(c[2]);
            var attrA = getAttributes(a, attr, caseSensitive);
            var attrB = getAttributes(b, attr, caseSensitive);

            if (attrA !== attrB && (attrA = (func !== nll) ? func(attrA, attrB) : sortFunc(attrA, attrB), 0 !== attrA)) {
                return ord === desc ? attrA : -1 * attrA;
            }
        }
    }

    function sortElements(elements, criterias, caseSensitive, onCompare, sortFunc, isToggle, start, end) {
        var elemLen = getLen(elements, 0);
        var elementsMap = [];
        var elementsSorted = [];
        var added = 0;
        var i;

        if (0 < elemLen) {
            for (i = 0; i < elemLen; i++) {
                elementsMap.push({
                    i: i,
                    v: elements[i]
                });
            }

            elementsMap.sort(function (a, b) {
                return sortBy(a.v, b.v, criterias, caseSensitive, sortFunc);
            });

            if (desc === criterias[0][1] || elemLen !== end)
                elementsMap.reverse();

            elementsMap.map(function (e) {
                var element = elements[e.i];

                ("none" !== element.style.display && start && end) && (added++, added >= start && added <= end || (element.style.display = "none"));
                isValidFunction(onCompare) && onCompare(element);
                elementsSorted.push(element);
            });

            return elementsSorted;
        }
    }

    /**
	* @constructor
	*/
    function Compare(settings) {
        var instance = this;
        var options = instance.defaults;

        arguments[0] && "object" === typeof (arguments[0]) && (options = extendDefaults({}, instance.defaults, settings));

        instance.page = options["page"];
        instance.size = options["size"];
        instance.sort = function (demand, orderListToMatch) {
            var start = nll;
            var end = nll;
            var sortedMatchedHomes = [];
            var keyName = options["attrSort"]();
            var filters = options["filters"][keyName];
            var criterias = bindCriterias(options["attr"][keyName], options["attrOrd"][keyName], options["attrFunc"][keyName]);
            var matchedHomes = [];
            var toSort = [];
            var elementsToSort = [];
            var matchHomesCounts = 0;

            if (0 >= criterias.length) {
                return;
            }

            if (orderListToMatch) {
                toSort = orderListToMatch;
            } else {
                toSort = getElementsToSort(options["selector"], filters);
            }

            elementsToSort = toSort.filter(function (element) {
                return element.dataset.isMatchingHome === "false";
            });

            matchedHomes = toSort.filter(function (element) {
                return element.dataset.isMatchingHome  === "true";
            });


            (instance.size && instance.page && (end = instance.size * instance.page, start = end - instance.size + 1));
            instance.isToggle = !0 === demand ? !1 : instance.keyName === keyName && options["toggle"] && !instance.isToggle;
            instance.keyName = keyName;

            if (matchedHomes) {
            sortedMatchedHomes = sortElements(matchedHomes, criterias, options["caseSensitive"], options["onCompare"],
                options["naturalSort"] ? naturalSort : defaultSort, instance.isToggle, start, end);
            matchHomesCounts = matchedHomes.length;
            }

            var isDesc = desc === criterias[0][1] || getLen(elementsToSort, 0) !== end;
            var sorted = sortElements(elementsToSort, criterias, options["caseSensitive"], options["onCompare"],
                options["naturalSort"] ? naturalSort : defaultSort, instance.isToggle, start, end - matchHomesCounts);
            var elementsForDom = sortedMatchedHomes ? sortedMatchedHomes.concat(sorted) : sorted ;

            if (elementsForDom) {
              applyToDom(elementsForDom, isDesc);
            }
            
            if (typeof options["afterCompare"] === "function") options["afterCompare"]();
        };

        attachBind(instance.sort, options["trigger"], options["event"]);
    }

    Compare.prototype.defaults = {
        "selector": nll,
        "attr": {},
        "attrOrd": {},
        "attrFunc": {},
        "attrSort": function () { return "defaults"; },
        "filters": {},
        "trigger": nll,
        "event": nll,
        "caseSensitive": !1,
        "naturalSort": !1,
        "toggle": !1,
        "beforeCompare": nll,
        "onCompare": nll,
        "afterCompare": nll,
        "onError": nll,
        "size": nll,
        "page": nll
    };

    $["Compare"] = $["compare"] = function () {
        return new Compare(arguments[0]);
    };
}(window));
